// extra-fx-text — text/ASCII effects
// ASCII art, Glitch text overlay

const N = (v) => Number(v) || 0;

// ---- ASCII art ----
const ASCII_CHARS = ' .:-=+*#%@';
const asciiArt = async (canvas, ctx, cols, invert) => {
    const w = canvas.width, h = canvas.height;
    const img = ctx.getImageData(0, 0, w, h);
    const data = img.data;
    const numCols = Math.max(8, Math.floor(N(cols)));
    const charW = w / numCols;
    const charH = charW * 1.8; // approximate aspect ratio
    const numRows = Math.floor(h / charH);
    const inv = N(invert) > 0;
    // Fill background
    ctx.fillStyle = '#000000';
    ctx.fillRect(0, 0, w, h);
    ctx.fillStyle = '#00ff00';
    const fontSize = Math.max(6, Math.floor(charW));
    ctx.font = `${fontSize}px monospace`;
    ctx.textBaseline = 'top';
    for (let row = 0; row < numRows; row++) {
        for (let col = 0; col < numCols; col++) {
            const px = Math.floor(col * charW), py = Math.floor(row * charH);
            const pw = Math.max(1, Math.floor(charW)), ph = Math.max(1, Math.floor(charH));
            let sum = 0, count = 0;
            for (let y = py; y < py + ph && y < h; y++) for (let x = px; x < px + pw && x < w; x++) {
                const i = (y * w + x) * 4;
                sum += 0.299*data[i] + 0.587*data[i+1] + 0.114*data[i+2];
                count++;
            }
            const lum = (sum / (count || 1)) / 255;
            const charIdx = inv
                ? Math.floor((1 - lum) * (ASCII_CHARS.length - 1))
                : Math.floor(lum * (ASCII_CHARS.length - 1));
            const ch = ASCII_CHARS[Math.max(0, Math.min(ASCII_CHARS.length - 1, charIdx))];
            // Color from original pixel
            const ci = (py * w + px) * 4;
            ctx.fillStyle = `rgb(${data[ci]},${data[ci+1]},${data[ci+2]})`;
            ctx.fillText(ch, col * charW, row * charH);
        }
    }
};

// ---- Glitch text overlay ----
const GLITCH_CHARS = '01ﾊﾐﾋｰｳｼﾅﾓﾆｻﾜﾂｵﾘｱﾎﾃﾏｹﾒｴｶｷﾑﾕﾗｾﾈｽﾀﾇﾍ¦|*+<>?#$%';
const glitchText = async (canvas, ctx, density, speed) => {
    const w = canvas.width, h = canvas.height;
    const img = ctx.getImageData(0, 0, w, h);
    const data = img.data;
    const dens = N(density) / 100;
    const colW = 8;
    const numCols = Math.floor(w / colW);
    const numRows = Math.floor(h / 14);
    // Draw text overlay on top of existing image
    ctx.font = '12px monospace';
    ctx.textBaseline = 'top';
    for (let row = 0; row < numRows; row++) {
        for (let col = 0; col < numCols; col++) {
            if (Math.random() > dens) continue;
            const px = col * colW, py = row * 14;
            const i = (py * w + px) * 4;
            const lum = (0.299*data[i] + 0.587*data[i+1] + 0.114*data[i+2]) / 255;
            if (lum < 0.3) continue; // skip dark areas
            const ch = GLITCH_CHARS[Math.floor(Math.random() * GLITCH_CHARS.length)];
            // Blend: draw char with semi-transparency
            ctx.fillStyle = `rgba(${data[i]},${data[i+1]},${data[i+2]},0.7)`;
            ctx.fillText(ch, px, py);
        }
    }
};

const descriptors = [
    { name: 'text-ascii', inputs: [
        { name: 'Columns', type: 'knob', min: 8, max: 200, step: 1, value: 80 },
        { name: 'Invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }], fn: asciiArt },
    { name: 'text-glitch-overlay', inputs: [
        { name: 'Density', type: 'knob', min: 0, max: 100, step: 1, value: 30 },
        { name: 'Speed', type: 'knob', min: 0, max: 100, step: 1, value: 50 }], fn: glitchText },
];

const lib = {};
descriptors.forEach(d => lib[d.name] = d.fn);

module.exports = { descriptors, lib };
